module.exports = __webpack_public_path__ + "static/media/Team25.75c3a97a.PNG";